<template>
  <!-- <v-footer
    color="white"
    class="pa-0"
    absolute>
    <v-row>
      <v-col class="p-0">
        <v-card
          align="center"
          justify="center"
          flat tile>
          <v-card-text class="caption font-weight-bold red--text text-center py-2">
            Copyright2020 &copy; esd.co.id
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-footer> -->
  <div :class="token === ''?'caption white--text background-pink':''">
    <v-container class="py-0">
      <div :class="token === ''? 'caption font-weight-bold white--text text-center py-2':'caption font-weight-bold red--text text-center py-2'">
        Copyright 2020 &copy; Era Solusi Data
      </div>
    </v-container>
  </div>
</template>
<script>
export default {
  computed: {
    token () {
      return this.$store.state.token
    },
  },
}
</script>
<style scoped>
/* BACKGROUND */
.background-pink {
  background-color: #FF618A !important;
}
</style>